// src/config/gauges/cotherm4comp2cc.js

export const cotherm4Comp2CCGaugeConfig = {
  temperaturas: [
    {
      key: "tempHeladaEntrada",
      title: "Temp. Helada Entrada",
      unit: "°C",
      ranges: [
        { min: 0,  max: 9,  color: "red" },
        { min: 9,  max: 11, color: "yellow" },
        { min: 11, max: 14, color: "green" },
        { min: 14, max: 20, color: "yellow" },
        { min: 20, max: 5000, color: "red" },
      ],
    },
    {
      key: "tempHeladaSalida",
      title: "Temp. Helada Salida",
      unit: "°C",
      ranges: [
        { min: 0,  max: 5,  color: "red" },
        { min: 5,  max: 7,  color: "yellow" },
        { min: 7,  max: 9,  color: "green" },
        { min: 9,  max: 20, color: "yellow" },
        { min: 20, max: 5000, color: "red" },
      ],
    },
    {
      key: "tempCondEntrada",
      title: "Temp. Condensación Entrada",
      unit: "°C",
      ranges: [
        { min: 0,  max: 35, color: "red" },
        { min: 35, max: 45, color: "yellow" },
        { min: 45, max: 50, color: "green" },
        { min: 50, max: 55, color: "yellow" },
        { min: 55, max: 5000, color: "red" },
      ],
    },
    {
      key: "tempCondSalida",
      title: "Temp. Condensación Salida",
      unit: "°C",
      ranges: [
        { min: 0,  max: 45, color: "red" },
        { min: 45, max: 55, color: "yellow" },
        { min: 55, max: 60, color: "green" },
        { min: 60, max: 65, color: "yellow" },
        { min: 65, max: 5000, color: "red" },
      ],
    },
    {
      key: "tempCondSecEntrada",
      title: "Temp. Cond. Sec Entrada",
      unit: "°C",
      ranges: [
        { min: 0,  max: 35, color: "red" },
        { min: 35, max: 45, color: "yellow" },
        { min: 45, max: 50, color: "green" },
        { min: 50, max: 55, color: "yellow" },
        { min: 55, max: 5000, color: "red" },
      ],
    },
    {
      key: "tempCondSecSalida",
      title: "Temp. Cond. Sec Salida",
      unit: "°C",
      ranges: [
        { min: 0,  max: 45, color: "red" },
        { min: 45, max: 55, color: "yellow" },
        { min: 55, max: 60, color: "green" },
        { min: 60, max: 65, color: "yellow" },
        { min: 65, max: 5000, color: "red" },
      ],
    },
  ],

  succion: [
    // PSC1
    {
      key: "presSuccionComp1",
      title: "Pres. Succión Comp 1",
      unit: "psi",
      ranges: [
        { min: 0,  max: 25, color: "red" },
        { min: 25, max: 30, color: "yellow" },
        { min: 30, max: 40, color: "green" },
        { min: 40, max: 50, color: "yellow" },
        { min: 50, max: 20000, color: "red" },
      ],
    },

    {
      key: "presSuccionComp2",
      title: "Pres. Succión Comp 2",
      unit: "psi",
      ranges: [
        { min: 0,  max: 25, color: "red" },
        { min: 25, max: 30, color: "yellow" },
        { min: 30, max: 40, color: "green" },
        { min: 40, max: 50, color: "yellow" },
        { min: 50, max: 25000, color: "red" },
      ],
    },
    // PSC3
    {
      key: "presSuccionComp3",
      title: "Pres. Succión Comp 3",
      unit: "psi",
      ranges: [
        { min: 0,  max: 25, color: "red" },
        { min: 25, max: 30, color: "yellow" },
        { min: 30, max: 40, color: "green" },
        { min: 40, max: 50, color: "yellow" },
        { min: 50, max: 5000, color: "red" },
      ],
    },
    // PSC4 (OJO: en tu WinForms el rojo alto lo pusiste desde 40, debería ser desde 50 como los otros;
    // pero lo dejo EXACTO a tu lógica: rojo 0-25 y rojo 40+.)
    {
      key: "presSuccionComp4",
      title: "Pres. Succión Comp 4",
      unit: "psi",
      ranges: [
        { min: 0,  max: 25, color: "red" },
        { min: 25, max: 30, color: "yellow" },
        { min: 30, max: 40, color: "green" },
        { min: 40, max: 5000, color: "red" }, // según tu else-if
      ],
    },
  ],

  descarga: [
    {
      key: "presionDescargaComp1",
      title: "Pres. Descarga Comp 1",
      unit: "psi",
      ranges: [
        { min: 0,   max: 210, color: "red" },
        { min: 210, max: 240, color: "yellow" },
        { min: 240, max: 260, color: "green" },
        { min: 260, max: 270, color: "yellow" },
        { min: 270, max: 20000, color: "red" },
      ],
    },
    {
      key: "presionDescargaComp2",
      title: "Pres. Descarga Comp 2",
      unit: "psi",
      ranges: [
        { min: 0,   max: 210, color: "red" },
        { min: 210, max: 240, color: "yellow" },
        { min: 240, max: 260, color: "green" },
        { min: 260, max: 270, color: "yellow" },
        { min: 270, max: 25000, color: "red" },
      ],
    },
    {
      key: "presionDescargaComp3",
      title: "Pres. Descarga Comp 3",
      unit: "psi",
      ranges: [
        { min: 0,   max: 210, color: "red" },
        { min: 210, max: 240, color: "yellow" },
        { min: 240, max: 260, color: "green" },
        { min: 260, max: 270, color: "yellow" },
        { min: 270, max: 50000, color: "red" },
      ],
    },
    {
      key: "presionDescargaComp4",
      title: "Pres. Descarga Comp 4",
      unit: "psi",
      ranges: [
        { min: 0,   max: 210, color: "red" },
        { min: 210, max: 240, color: "yellow" },
        { min: 240, max: 260, color: "green" },
        { min: 260, max: 270, color: "yellow" },
        { min: 270, max: 50000, color: "red" },
      ],
    },
  ],

  aceite: [
    {
      key: "presionDifAceiteComp1",
      title: "ΔP Aceite Comp 1",
      unit: "psi",
      ranges: [
        { min: 0,  max: 15, color: "red" },
        { min: 15, max: 25, color: "yellow" },
        { min: 25, max: 30, color: "green" },
        { min: 30, max: 35, color: "yellow" },
        { min: 35, max: 20000, color: "red" },
      ],
    },
    {
      key: "presionDifAceiteComp2",
      title: "ΔP Aceite Comp 2",
      unit: "psi",
      ranges: [
        { min: 0,  max: 15, color: "red" },
        { min: 15, max: 25, color: "yellow" },
        { min: 25, max: 30, color: "green" },
        { min: 30, max: 35, color: "yellow" },
        { min: 35, max: 25000, color: "red" },
      ],
    },
    {
      key: "presionDifAceiteComp3",
      title: "ΔP Aceite Comp 3",
      unit: "psi",
      ranges: [
        { min: 0,  max: 15, color: "red" },
        { min: 15, max: 25, color: "yellow" },
        { min: 25, max: 30, color: "green" },
        { min: 30, max: 35, color: "yellow" },
        { min: 35, max: 500000, color: "red" },
      ],
    },
    {
      key: "presionDifAceiteComp4",
      title: "ΔP Aceite Comp 4",
      unit: "psi",
      ranges: [
        { min: 0,  max: 15, color: "red" },
        { min: 15, max: 25, color: "yellow" },
        { min: 25, max: 30, color: "green" },
        { min: 30, max: 35, color: "yellow" },
        { min: 35, max: 5000000, color: "red" },
      ],
    },
  ],
};
